import { RouteRecordRaw } from 'vue-router'
import BaseLayoutView from '@/views/layout/BaseLayoutView.vue'
import JunshisanSetting from '@/views/fuzoku-meisai/junsoku/JunshisanSetting.vue'
import ExportReport from '@/views/fuzoku-meisai/junsoku/ExportReport.vue'
import KyuyohiMeisaiSetting from '@/views/fuzoku-meisai/junsoku/KyuyohiMeisaiSetting.vue'
import HonbuhiSetting from '@/views/fuzoku-meisai/junsoku/HonbuhiSetting.vue'
import TanpokenSetting from '@/views/fuzoku-meisai/junsoku/TanpokenSetting.vue'
import HikiatekinSetting from '@/views/fuzoku-meisai/junsoku/HikiatekinSetting.vue'
import HojokinSetting from '@/views/fuzoku-meisai/junsoku/HojokinSetting.vue'
import KoteishisanSetting from '@/views/fuzoku-meisai/junsoku/KoteishisanSetting.vue'
import KashitsukekinSetting from '@/views/fuzoku-meisai/junsoku/KashitsukekinSetting.vue'
import KariirekinSetting from '@/views/fuzoku-meisai/junsoku/KariirekinSetting.vue'

export const fuzokuJunsokuRoute: RouteRecordRaw = {
  path: '/fuzoku',
  component: BaseLayoutView,
  children: [
    {
      path: 'junsoku',
      children: [
        { path: 'export', component: ExportReport },
        { path: 'junshisan', component: JunshisanSetting },
        { path: 'koteishisan', component: KoteishisanSetting },
        { path: 'kashitsukekin', component: KashitsukekinSetting },
        { path: 'kariirekin', component: KariirekinSetting },
        { path: 'hikiatekin', component: HikiatekinSetting },
        { path: 'hojokin', component: HojokinSetting },
        { path: 'tanpo', component: TanpokenSetting },
        { path: 'kyuyo', component: KyuyohiMeisaiSetting },
        { path: 'honbu', component: HonbuhiSetting }
      ]
    }
  ]
}
